import styled from "styled-components";

interface ICheckEmailStyleProps {
  disableShadow?: boolean;
  commonStyle?: any;
}

export const CheckEmailStyle = styled.div<ICheckEmailStyleProps>`
${({ theme, disableShadow, commonStyle }) => `
  .check-mail-title{
    margin: ${theme.uptimeSpace[8]}px ${theme.uptimeSpace[0]};
    &:after{
      content: '*';
      color: ${theme.uptimeColors.generalColors.state.danger.light};
      padding-left: ${theme.uptimeSpace[2]}px
    }
  }
  .section-email {
    box-shadow: ${disableShadow ? 'none' : '4px 10px 30px 4px rgb(36 14 47 / 6%)'};
    border-radius: ${theme.uptimeSpace[6]}px;
    padding: ${!!commonStyle?.padding ? commonStyle?.padding : `${theme.uptimeSpace[6]}px ${theme.uptimeSpace[12]}px`};
    .label-form {
      font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
      line-height: ${theme.uptimeLineHeights.desktop.lh4}px;
      font-weight: bold;
    }
    .required.label-form::after{
      content: '*';
      color: ${theme.uptimeColors.generalColors.state.danger.light};
    }
    .email-container{
      padding: 0;
      margin-top: 0 !important;
      .email-control {
        position: relative;
        .email-input {
          input {
            margin-right: auto;
          }
        }
        .group-button
        .icon-check {
          padding: ${theme.uptimeSpace[2]}px ${theme.uptimeSpace[7]}px;
          border-radius: ${theme.uptimeSpace[0]};
        }
      }
    }
    .hint-msg {
      font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
      button {
        margin-top: -3px;
        padding: ${theme.uptimeSpace[0]};
        background-color: transparent;
        text-transform: none;
        text-decoration: underline;
        font-family: ${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`};
        color: ${theme.uptimeColors.mainTheme.primary};
        line-height: 1;
      }
    }
    .info-user {
      color: ${theme.uptimeColors.grayScales.darkerGray};
      line-height: 0.3;
      p {
        font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
      }
    }
    .info-user-noedit{
      min-height: 100px;
    }
  }
  .section-email.section-email-check-user{
    box-shadow : none;
    padding : ${theme.uptimeSpace[0]};
    margin-top: ${theme.uptimeSpace[2]}px;
    .email-container{
      margin-top: 12px;
    }
    .label-form {
      font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
      line-height: ${theme.uptimeLineHeights.desktop.lh1}px;
    }
  }
  .delegation-user-selection{
        .MuiButtonBase-root{
            min-width: 104px !important;
        }
    }
`}
`;

export const StyledErrorMessage = styled('p')(({ theme }) => `
  color: ${theme.uptimeColors.generalColors.state.danger.light};
  font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
  line-height: 1;
  margin-bottom: 0;
`);